import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state = {
  absences: []
}

const namespaced = false

export const absence = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
